/**
 * All our SVG icons.
 */
import React from "react";
import styled from "styled-components";

/**
 * Cross close icon.
 */
export const CrossCloseIcon = (props) => {
  return (
    <svg
      style={{ cursor: "pointer" }}
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.846245 0.319298C1.27196 -0.106415 1.96222 -0.106433 2.38795 0.319298L7.52695 5.4583L12.6659 0.319298C13.0917 -0.106429 13.7819 -0.106436 14.2076 0.319298C14.6334 0.745015 14.6334 1.43526 14.2076 1.86099L9.06864 6.99999L14.2076 12.139C14.6334 12.5647 14.6334 13.255 14.2076 13.6807C13.7819 14.1064 13.0917 14.1064 12.6659 13.6807L7.52694 8.54168L2.38795 13.6807C1.96222 14.1064 1.27197 14.1064 0.846249 13.6807C0.42051 13.255 0.420517 12.5647 0.846249 12.139L5.98525 6.99999L0.846249 1.86099C0.420521 1.43526 0.420507 0.74504 0.846245 0.319298Z"
        fill="#BDBDBD"
      />
    </svg>
  );
};

/**
 * Send icon for the text input field.
 */
export const SendIcon = (props) => {
  const fillColor = props.fillColor || "#C2D6F1";
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.1782 8.66861L2.15165 0.156906C1.89354 0.0278903 1.60346 -0.0232397 1.31678 0.00975165C1.03011 0.042743 0.75923 0.15843 0.537189 0.342703C0.315148 0.526975 0.151539 0.771869 0.0663171 1.04751C-0.0189048 1.32316 -0.0220563 1.61765 0.0572471 1.89505L2.23119 9.50284H9.99895C10.1304 9.50284 10.2564 9.55505 10.3494 9.64798C10.4423 9.7409 10.4945 9.86694 10.4945 9.99835C10.4945 10.1298 10.4423 10.2558 10.3494 10.3487C10.2564 10.4417 10.1304 10.4939 9.99895 10.4939H2.23119L0.0572471 18.1017C-0.00536457 18.3227 -0.0160833 18.5552 0.0259265 18.781C0.0679362 19.0068 0.16154 19.2199 0.299441 19.4036C0.437342 19.5874 0.615817 19.7368 0.820954 19.8402C1.02609 19.9437 1.25235 19.9983 1.48209 20C1.71479 19.9995 1.94414 19.9446 2.15189 19.8398L19.1782 11.3281C19.4251 11.2046 19.6328 11.0148 19.778 10.7799C19.9231 10.5451 20 10.2744 20 9.99835C20 9.72227 19.9231 9.45165 19.778 9.21679C19.6328 8.98193 19.4251 8.79211 19.1782 8.66861Z"
        fill={fillColor}
      />
    </svg>
  );
};

/**
 * Triangle in a circle icon.
 * @param props
 * @constructor
 */
export const PlayIcon = (props) => {
  const { className, style } = props;
  return (
    <svg
      className={className}
      style={style}
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="27.5" cy="27.5" r="23.5" fill="white" />
      <g filter="url(#filter0_d)">
        <path
          fill="currentColor"
          d="M27.5 4C14.5214 4 4 14.5214 4 27.5C4 40.4786 14.5214 51 27.5 51C40.4786 51 51 40.4786 51 27.5C51 14.5214 40.4786 4 27.5 4ZM22.2859 16.3375C22.712 16.3275 23.16 16.439 23.5895 16.6864L37.3957 25.1867C38.1481 25.651 38.6625 26.5032 38.6625 27.5C38.6625 28.4968 38.1481 29.349 37.3957 29.8133L23.5895 38.3136C21.8715 39.3032 19.9062 38.0423 19.8625 35.9636V19.018C19.8952 17.4589 21.0077 16.3681 22.2859 16.3375Z"
        />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="0"
          y="0"
          width="55"
          height="55"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

/**
 * Pencil icon.
 * @param props
 * @constructor
 */
export const PencilIcon = (props) => {
  const fillColor = props.fillColor || "#D8DFE9";
  const fillOpacity = props.fillOpacity || "1";
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.02006 13.9478L5.45587 13.512L1.48797 9.54413L10.4158 0.616335C11.2375 -0.205445 12.5699 -0.205445 13.3917 0.616335L14.3837 1.60831C15.2054 2.43009 15.2054 3.76246 14.3837 4.58424L5.02006 13.9478ZM4.45902 14.4991C4.08002 14.8213 3.59736 15 3.09628 15H0.350717C0.157021 15 0 14.843 0 14.6493V11.9037C0 11.4026 0.17872 10.92 0.500859 10.541L4.45902 14.4991Z"
        fill={fillColor}
        fillOpacity={fillOpacity}
      />
    </svg>
  );
};

/**
 * Checkbox icon for the editable messages.
 * @constructor
 */
export const CheckboxIcon = () => {
  return (
    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.5148 0.000409256C10.2456 0.00865532 9.99023 0.12142 9.8028 0.314792L4.53689 5.58072L1.70745 3.34304C1.60154 3.2528 1.47854 3.18484 1.34579 3.14318C1.21303 3.10153 1.07325 3.08705 0.934772 3.10061C0.796299 3.11417 0.661978 3.15549 0.539827 3.2221C0.417676 3.28872 0.310199 3.37927 0.223812 3.48834C0.137426 3.59741 0.0739011 3.72277 0.0370297 3.85693C0.000158236 3.99109 -0.00930372 4.13131 0.0092087 4.26921C0.0277211 4.4071 0.0738284 4.53985 0.144778 4.65954C0.215728 4.77923 0.310065 4.88339 0.422159 4.96581L3.97284 7.77677C4.17168 7.93396 4.42127 8.01279 4.67433 7.99831C4.92739 7.98382 5.16635 7.87704 5.34596 7.69819L11.2638 1.78037C11.4139 1.63523 11.5167 1.44811 11.5586 1.24354C11.6005 1.03897 11.5795 0.826499 11.4985 0.634025C11.4176 0.44155 11.2803 0.27805 11.1047 0.164978C10.9292 0.051906 10.7235 -0.00545944 10.5148 0.000409256Z"
        fill="#D8DFE9"
      />
    </svg>
  );
};

/**
 * Day switch arrow for the calendar.
 * @param props
 * @returns {*}
 * @constructor
 */
export const Arrow = (props) => {
  const { className, onClick, fillColor = "#387BFF" } = props;
  // Unusually wrapped with a div to make the hover state with the background work.
  // There are other approaches as well.
  return (
    <div {...{ className, onClick }}>
      <svg
        style={{ cursor: "pointer" }}
        width="12"
        height="18"
        viewBox="0 0 12 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.1 2.1L9 0L0 9L9 18L11.1 15.9L4.2 9L11.1 2.1Z"
          fill={fillColor}
        />
      </svg>
    </div>
  );
};

/**
 * An arrow with rounded borders.
 * https://www.figma.com/file/qEuSRMddbMeplfUC1HaMzx/familyassets?node-id=850%3A309
 */
export const ArrowRoundBorders = (props) => {
  return (
    <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 14L1 7.5L8 1" stroke="#BDBDBD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

const NavSVG = styled.svg`
  cursor: pointer;
  top: calc(50% - 15px);
  z-index: 1;
  transition: all 0.2s ease-out;

  &:hover {
    transform: scale(1.1);
    color: ${(props) => props.theme.brandColor || "#337ab7"};
  }

  &.left {
    transform: rotate(180deg);

    &:hover {
      transform: rotate(180deg) scale(1.1);
    }
  }
`;

/**
 * Gallery navigation arrow.
 * @param props
 * @returns {*}
 * @constructor
 */
export const GalleryNavArrow = (props) => {
  const { className, onClick, fillColor = "#387BFF" } = props;
  return (
    <NavSVG
      {...{ className, onClick }}
      fill="none"
      stroke="currentColor"
      version="1.1"
      width="18"
      height="31"
      viewBox="0 0 18 31"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2 2L16 15.5L2 29" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    </NavSVG>
  );
};

export const GalleryCloseIcon = (props) => {
  return (
    <svg
      width="26"
      height="27"
      viewBox="0 0 26 27"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      stroke="currentColor"
      version="1.1"
    >
      <path d="M2 2.5L24 24.5" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2 24.5L24 2.5" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const GalleryMobileCloseIcon = (props) => {
  const { className, onClick } = props;
  return (
    <svg
      {...{ className, onClick }}
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d)">
        <circle cx="27" cy="25" r="21" fill="#EAF2FD" />
      </g>
      <path
        d="M20.3193 18.3193C20.745 17.8936 21.4353 17.8936 21.861 18.3193L27 23.4583L32.139 18.3193C32.5647 17.8936 33.255 17.8936 33.6807 18.3193C34.1064 18.745 34.1064 19.4353 33.6807 19.861L28.5417 25L33.6807 30.139C34.1064 30.5647 34.1064 31.255 33.6807 31.6807C33.255 32.1064 32.5647 32.1064 32.139 31.6807L27 26.5417L21.861 31.6807C21.4353 32.1064 20.745 32.1064 20.3193 31.6807C19.8936 31.255 19.8936 30.5647 20.3193 30.139L25.4583 25L20.3193 19.861C19.8936 19.4353 19.8936 18.745 20.3193 18.3193Z"
        fill="#387BFF"
      />
      <defs>
        <filter
          id="filter0_d"
          x="0"
          y="0"
          width="54"
          height="54"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export const NextArrow = (props) => {
  return (
    <svg width="5" height="7" viewBox="0 0 5 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.36865 1.47363L3.89497 3.68416L1.36865 5.89469"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CareTypeIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
      <circle cx="24" cy="24" r="24" fill="#EFEFF2" />
      <path
        d="M1.24719 1.09613C1.38452 0.986267 1.57678 0.986267 1.74157 1.0412L8.52559 3.87016L15.3096 1.0412C15.4469 0.986267 15.5843 0.986267 15.7216 1.0412L22.6704 3.95256C22.8627 4.03496 23 4.22722 23 4.44694V22.4644C23 22.6292 22.9176 22.794 22.7803 22.9039C22.6979 22.9588 22.588 22.9863 22.4782 22.9863C22.4232 22.9863 22.3408 22.9863 22.2859 22.9588L15.5019 20.1298L8.71785 22.9588C8.58052 23.0137 8.4432 23.0137 8.30587 22.9588L1.32959 20.0474C1.13733 19.965 1 19.7728 1 19.5531V1.53558C1.02747 1.37079 1.10986 1.20599 1.24719 1.09613ZM14.98 2.33208L9.04744 4.80399V21.6954L14.98 19.2235V2.33208ZM15.4744 2.11236H15.5568L15.5293 2.08489L15.4744 2.11236ZM21.9563 4.80399L16.0237 2.33208V19.2235L21.9563 21.6954V4.80399ZM8.52559 21.8876H8.55306H8.47066H8.52559ZM2.07116 19.196L8.00375 21.6679V4.80399L2.07116 2.33208V19.196Z"
        fill="#6F6E82"
        stroke="#6F6E82"
        transform="translate(12 12)"
      />
    </svg>
  );
};

export const RulerIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
      <circle cx="24" cy="24" r="24" fill="#EFEFF2" />
      <path
        d="M2.84585 20.3077L7.92278 15.2308H8.46154H20.3077V20.3077H18.6154V18.6154C18.6154 18.1481 18.2369 17.7692 17.7692 17.7692C17.3016 17.7692 16.9231 18.1481 16.9231 18.6154V20.3077H15.2308V18.6154C15.2308 18.1481 14.8523 17.7692 14.3846 17.7692C13.9169 17.7692 13.5385 18.1481 13.5385 18.6154V20.3077H11.8462V18.6154C11.8462 18.1481 11.4677 17.7692 11 17.7692C10.5323 17.7692 10.1538 18.1481 10.1538 18.6154V20.3077H8.46154V18.6154C8.46154 18.1481 8.08308 17.7692 7.61538 17.7692C7.14769 17.7692 6.76923 18.1481 6.76923 18.6154V20.3077H2.84585ZM14.3846 22H17.7692H20.3077C21.2423 22 22 21.2424 22 20.3077V15.2308C22 14.2961 21.2423 13.5385 20.3077 13.5385H10.1538H8.46154V11.8462V1.69231C8.46154 0.757634 7.7038 0 6.76923 0H1.69231C0.757738 0 0 0.757634 0 1.69231V4.23077V7.61538V11V14.3846V15.2308V20.3077C0 21.2424 0.757738 22 1.69231 22H6.76923H7.61538H11H14.3846ZM6.76923 13.9914L1.69231 19.0684V15.2308H3.38462C3.85231 15.2308 4.23077 14.8519 4.23077 14.3846C4.23077 13.9174 3.85231 13.5385 3.38462 13.5385H1.69231V11.8462H3.38462C3.85231 11.8462 4.23077 11.4672 4.23077 11C4.23077 10.5328 3.85231 10.1538 3.38462 10.1538H1.69231V8.46154H3.38462C3.85231 8.46154 4.23077 8.08267 4.23077 7.61538C4.23077 7.1481 3.85231 6.76923 3.38462 6.76923H1.69231V5.07692H3.38462C3.85231 5.07692 4.23077 4.69806 4.23077 4.23077C4.23077 3.76348 3.85231 3.38462 3.38462 3.38462H1.69231V1.69231H6.76923V13.5385V13.9914Z"
        fill="#141233"
        fillRule="evenodd"
        clipRule="evenodd"
        fillOpacity="0.6"
        transform="translate(12 12)"
      />
    </svg>
  );
};

export const HeartHandIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
      <circle cx="24" cy="24" r="24" fill="#EFEFF2" />
      <path
        d="M20.6422 18.4607C19.9877 17.5608 18.7607 17.3427 17.8881 17.9426C16.661 18.7879 14.6431 20.1786 13.9614 20.6421L10.9074 20.5331C10.8801 20.5331 10.8528 20.5058 10.8256 20.4785C10.8256 20.4785 10.7983 20.424 10.8256 20.3967C10.8528 20.3422 10.8801 20.3422 10.9074 20.3422L12.8434 20.124C13.8523 20.015 14.6159 19.1424 14.5886 18.1062V18.0789C14.5341 17.07 13.716 16.2519 12.6798 16.2247L7.25339 16.0883C6.78983 16.0611 6.32627 16.1701 5.94451 16.4155L0 20.124L3.21767 26.3958L5.3446 24.8687C5.91724 24.4597 6.62622 24.2688 7.3352 24.3779L12.3526 25.1414C13.5524 25.3323 14.7522 25.0324 15.7339 24.3234L20.1513 21.1602C21.0512 20.5331 21.2693 19.3333 20.6422 18.4607ZM19.2242 19.8241L14.8067 22.9872C14.1796 23.4508 13.3888 23.6417 12.6253 23.5053L7.58061 22.7418C6.43534 22.5782 5.31734 22.8509 4.36294 23.5053L3.79031 23.9143L2.12693 20.6694L6.78983 17.7517C6.8989 17.6972 7.00798 17.6426 7.14432 17.6699L12.598 17.8062C12.7616 17.8062 12.9252 17.9426 12.9252 18.1062C12.9252 18.2698 12.7889 18.4061 12.6253 18.4334L10.6892 18.6515C10.1166 18.7061 9.62574 19.0606 9.35306 19.5514C9.08037 20.0422 9.08037 20.6421 9.32579 21.1602C9.59847 21.7329 10.1711 22.0874 10.7983 22.1146L14.3977 22.251L14.6159 22.0874C14.6159 22.0874 17.2882 20.2331 18.7607 19.2242C18.9243 19.1151 19.1151 19.1696 19.2515 19.306L19.2788 19.3333C19.4151 19.5241 19.3606 19.7423 19.2242 19.8241Z"
        fill="#141233"
        fillOpacity="0.6"
        transform="translate(12 12)"
      />
      <path
        d="M7.71699 7.90786C7.22616 10.4438 8.72592 13.7978 13.1707 15.5703C13.307 15.6248 13.4706 15.6521 13.607 15.6521C13.7433 15.6521 13.9069 15.6248 14.0433 15.5703C18.4607 13.7433 19.9605 10.4166 19.4697 7.88059C19.0879 5.99907 17.7245 4.79926 15.9793 4.79926C15.2158 4.79926 14.3977 5.04468 13.607 5.53551C12.8162 5.04468 11.9981 4.79926 11.2073 4.79926C9.48943 4.772 8.07148 6.02634 7.71699 7.90786ZM9.32582 8.20781C9.54397 7.11708 10.2529 6.4081 11.2073 6.4081C11.78 6.4081 12.4617 6.68078 13.1161 7.17161L13.607 7.5261L14.0978 7.17161C14.7522 6.68078 15.4067 6.43537 15.9793 6.43537C16.9337 6.43537 17.6427 7.11708 17.8608 8.20781C18.2153 10.0348 17.0155 12.5162 13.607 13.9887C10.1439 12.5435 8.97133 10.0621 9.32582 8.20781Z"
        fill="#141233"
        fillOpacity="0.6"
        transform="translate(12 12)"
      />
      <path
        d="M13.4977 3.46309C13.9613 3.46309 14.3158 3.1086 14.3158 2.64503V0.818052C14.3158 0.354489 13.9613 0 13.4977 0C13.0342 0 12.6797 0.354489 12.6797 0.818052V2.64503C12.6797 3.1086 13.0342 3.46309 13.4977 3.46309Z"
        fill="#141233"
        fillOpacity="0.6"
        transform="translate(12 12)"
      />
      <path
        d="M17.8605 4.30842C17.9696 4.36296 18.1059 4.39023 18.2423 4.39023C18.5422 4.39023 18.8149 4.22661 18.9785 3.95393L19.9056 2.12695C20.1238 1.71792 19.9602 1.22709 19.5511 1.03621C19.1421 0.818066 18.6513 0.981676 18.4604 1.3907L17.5333 3.21768C17.2879 3.62671 17.4515 4.11754 17.8605 4.30842Z"
        fill="#141233"
        fillOpacity="0.6"
        transform="translate(12 12)"
      />
      <path
        d="M8.18039 3.95393C8.31674 4.22661 8.61669 4.39023 8.91664 4.39023C9.05298 4.39023 9.16206 4.36296 9.2984 4.30842C9.70742 4.09027 9.87103 3.59944 9.65289 3.21768L8.72576 1.3907C8.50761 0.981676 8.01678 0.818066 7.63503 1.03621C7.226 1.25436 7.06239 1.74519 7.28054 2.12695L8.18039 3.95393Z"
        fill="#141233"
        fillOpacity="0.6"
        transform="translate(12 12)"
      />
    </svg>
  );
};

export const FloorPlanIcon = (props) => {
  const { fillColor = "#387BFF" } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="50"
      viewBox="0 0 50 50"
      preserveAspectRatio="xMidYMid meet"
    >
      <g transform="translate(0.000000,50.000000) scale(0.100000,-0.100000)" fill={fillColor} stroke="none">
        <path d="M40 250 l0 -210 210 0 210 0 0 210 0 210 -75 0 c-43 0 -75 -4 -75 -10 0 -6 28 -10 65 -10 l65 0 0 -100 0 -100 -35 0 c-19 0 -35 -4 -35 -10 0 -5 16 -10 35 -10 l35 0 0 -80 0 -80 -100 0 -100 0 0 80 0 80 35 0 c19 0 35 5 35 10 0 6 -33 10 -80 10 -47 0 -80 -4 -80 -10 0 -5 16 -10 35 -10 l35 0 0 -80 0 -80 -80 0 -80 0 0 190 0 190 63 0 c55 0 69 -4 105 -31 26 -19 42 -26 42 -17 0 7 -18 25 -39 41 -34 24 -48 27 -115 27 l-76 0 0 -210z" />
      </g>
    </svg>
  );
};

export const VideosIcon = (props) => {
  return (
    <svg
      width="55"
      height="25"
      aria-hidden="true"
      focusable="false"
      data-prefix="fal"
      data-icon="photo-video"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 512"
      className="svg-inline--fa fa-photo-video fa-w-20 fa-3x"
    >
      <path
        fill="rgb(173, 181, 189)"
        d="M608 0H160c-17.67 0-32 13.13-32 29.33V128h128V32h256v288h-32v32h128c17.67 0 32-13.13 32-29.33V29.33C640 13.13 625.67 0 608 0zM224 96h-64V32h64zm384 224h-64v-64h64zm0-96h-64v-96h64zm0-128h-64V32h64zm-192 64H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zm0 320H32v-24l81.69-61.26 80 40 126.84-95.14L416 403.23zm0-115.23l-96.53-64.36-129.16 96.86-80-40L32 416V192h384zM112 320a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm0-64a16 16 0 1 1-16 16 16 16 0 0 1 16-16z"
      />
    </svg>
  );
};

/**
 * https://www.figma.com/file/qEuSRMddbMeplfUC1HaMzx/familyassets?node-id=850%3A147
 */
export const PhoneIcon = (props) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.89163 0.885532C3.75896 0.443302 3.62629 0.089518 3.18406 0.045295L2.34382 0.00107196C1.45936 -0.0431511 0 1.28354 0 3.49469C0.044223 7.34209 5.79322 13.6218 9.5964 13.9755C11.8518 14.1967 13.2669 12.87 13.3111 11.9413V11.1453C13.3554 10.703 13.0016 10.5262 12.5593 10.3493C11.7191 10.0397 10.8789 9.64169 10.0386 9.33213C9.68484 9.19946 9.37528 9.42058 9.15417 9.55324C8.84461 9.81858 8.62349 9.99547 8.35815 10.305C8.13704 10.4819 7.91592 10.5704 7.69481 10.3493C5.79322 9.37635 4.24541 7.69588 3.4494 5.75006C3.2725 5.48473 3.36095 5.26361 3.58207 5.08672C3.89163 4.82138 4.11274 4.60027 4.37808 4.33493C4.55497 4.15804 4.77609 3.84847 4.68764 3.49469C4.4223 2.65445 4.15696 1.72577 3.89163 0.885532Z"
        fill="#C4C4C4"
      />
    </svg>
  );
};

/**
 * https://www.figma.com/file/qEuSRMddbMeplfUC1HaMzx/familyassets?node-id=885%3A95
 * Huge celebration image.
 */
export const TadaSvgImage = () => {
  return (
    <svg width="280" height="180" viewBox="0 0 280 180" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.1">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M142.829 64.2329C111.024 64.2329 85.2406 90.0163 85.2406 121.822C85.2406 153.627 111.024 179.41 142.829 179.41C174.635 179.41 200.418 153.627 200.418 121.822C200.418 90.0163 174.635 64.2329 142.829 64.2329Z"
          fill="#307FE2"
        />
      </g>
      <rect x="99.8904" y="78.8827" width="85.8779" height="85.8779" rx="42.939" fill="#387BFF" />
      <path
        d="M129.078 120.523L126.411 123.193L135.839 132.635C136.576 133.372 137.77 133.372 138.506 132.635L159.247 111.863L156.581 109.193L137.173 128.629L129.078 120.523Z"
        fill="white"
        stroke="white"
        strokeWidth="1.95"
      />
      <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="125" y="107" width="36" height="28">
        <path
          d="M129.078 120.523L126.411 123.193L135.839 132.635C136.576 133.372 137.77 133.372 138.506 132.635L159.247 111.863L156.581 109.193L137.173 128.629L129.078 120.523Z"
          fill="white"
          stroke="white"
          strokeWidth="1.95"
        />
      </mask>
      <g mask="url(#mask0)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M271.646 117.275C274.436 117.275 276.698 115.013 276.698 112.224C276.698 109.434 274.436 107.172 271.646 107.172C268.856 107.172 266.595 109.434 266.595 112.224C266.595 115.013 268.856 117.275 271.646 117.275Z"
        stroke="#2979FF"
        strokeWidth="2.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.7965 32.4075C42.6335 32.4075 43.312 31.729 43.312 30.892C43.312 30.0551 42.6335 29.3766 41.7965 29.3766C40.9595 29.3766 40.281 30.0551 40.281 30.892C40.281 31.729 40.9595 32.4075 41.7965 32.4075Z"
        stroke="#1B7BE3"
        strokeWidth="0.75"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M89.7872 52.6142C92.5771 52.6142 94.8388 50.3525 94.8388 47.5626C94.8388 44.7726 92.5771 42.5109 89.7872 42.5109C86.9972 42.5109 84.7355 44.7726 84.7355 47.5626C84.7355 50.3525 86.9972 52.6142 89.7872 52.6142Z"
        stroke="#1DE9B6"
        strokeWidth="2.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.0952 151.626C24.3272 151.626 26.1365 149.817 26.1365 147.585C26.1365 145.353 24.3272 143.544 22.0952 143.544C19.8633 143.544 18.0539 145.353 18.0539 147.585C18.0539 149.817 19.8633 151.626 22.0952 151.626Z"
        stroke="#1DE9B6"
        strokeWidth="1.56"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M78.6735 146.575C80.3475 146.575 81.7045 145.218 81.7045 143.544C81.7045 141.87 80.3475 140.513 78.6735 140.513C76.9995 140.513 75.6425 141.87 75.6425 143.544C75.6425 145.218 76.9995 146.575 78.6735 146.575Z"
        stroke="#E5E5EE"
        strokeWidth="1.56"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M180.717 91.0066C181.275 91.0066 181.727 90.5543 181.727 89.9963C181.727 89.4383 181.275 88.986 180.717 88.986C180.159 88.986 179.707 89.4383 179.707 89.9963C179.707 90.5543 180.159 91.0066 180.717 91.0066Z"
        stroke="#E5E5EE"
        strokeWidth="0.75"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M177.686 50.5935C179.36 50.5935 180.717 49.2364 180.717 47.5625C180.717 45.8885 179.36 44.5315 177.686 44.5315C176.012 44.5315 174.655 45.8885 174.655 47.5625C174.655 49.2364 176.012 50.5935 177.686 50.5935Z"
        stroke="#FF9800"
        strokeWidth="1.56"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M268.512 154.389L274.337 146.435L278.033 155.215L268.512 154.389Z"
        stroke="#1DE9B6"
        strokeWidth="2.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M224.58 95.3053L230.029 91.3771L230.575 97.8449L224.58 95.3053Z"
        stroke="#FF9800"
        strokeWidth="1.56"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M210.471 92.1399L211.386 88.9554L213.441 91.4745L210.471 92.1399Z"
        stroke="#E5E5EE"
        strokeWidth="0.75"
      />
      <path
        d="M46.3145 54.4902L47.26 51.7444L48.533 52.1828L47.5876 54.9285L50.3333 55.874L49.895 57.147L47.1492 56.2016L46.2038 58.9474L44.9307 58.509L45.8762 55.7632L43.1304 54.8178L43.5687 53.5448L46.3145 54.4902Z"
        fill="#E5E5EE"
      />
      <path
        d="M3.2117 65.4664L3.7274 63.9687L4.42179 64.2078L3.90609 65.7055L5.40379 66.2212L5.16469 66.9156L3.66699 66.3999L3.15129 67.8976L2.4569 67.6585L2.9726 66.1608L1.4749 65.6451L1.714 64.9507L3.2117 65.4664Z"
        fill="#E5E5EE"
      />
      <path
        d="M66.9847 70.66L67.1503 69.0847L67.8807 69.1615L67.7151 70.7368L69.2904 70.9024L69.2137 71.6328L67.6383 71.4672L67.4728 73.0425L66.7424 72.9657L66.908 71.3904L65.3326 71.2249L65.4094 70.4945L66.9847 70.66Z"
        fill="#E5E5EE"
      />
      <path
        d="M143.77 28.2262L143.935 26.6509L144.666 26.7277L144.5 28.303L146.075 28.4686L145.999 29.199L144.423 29.0334L144.258 30.6087L143.527 30.5319L143.693 28.9566L142.118 28.791L142.194 28.0607L143.77 28.2262Z"
        fill="#E5E5EE"
      />
      <path
        d="M34.9499 99.7317L33.9919 95.8893L35.7733 95.4451L36.7314 99.2875L40.5737 98.3295L41.0179 100.111L37.1755 101.069L38.1335 104.911L36.3521 105.356L35.3941 101.513L31.5517 102.471L31.1075 100.69L34.9499 99.7317Z"
        fill="#2979FF"
      />
      <path
        d="M204.159 12.6838L205.833 9.09478L207.497 9.87071L205.823 13.4597L209.412 15.1333L208.636 16.7972L205.047 15.1237L203.373 18.7126L201.709 17.9367L203.383 14.3477L199.794 12.6742L200.57 11.0102L204.159 12.6838Z"
        fill="#FF9800"
      />
      <path
        d="M248.226 60.7331L249.342 58.3405L250.452 58.8578L249.336 61.2504L251.728 62.3661L251.211 63.4754L248.819 62.3597L247.703 64.7524L246.593 64.2351L247.709 61.8424L245.317 60.7267L245.834 59.6174L248.226 60.7331Z"
        fill="#ADADBD"
      />
    </svg>
  );
};

export const BoltIcon = (props) => {
  const { fillColor = "#FFFFFF" } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      preserveAspectRatio="xMidYMid meet"
    >
      <g>
        <path
          fill={fillColor}
          d="M 9.3125 4.671875 C 9.246094 4.5625 9.125 4.5 9 4.5 L 6.375 4.5 L 6.375 0.375 C 6.375 0.199219 6.25 0.046875 6.078125 0.0078125 C 5.902344 -0.0273438 5.730469 0.0625 5.65625 0.222656 L 2.65625 6.972656 C 2.605469 7.089844 2.617188 7.222656 2.6875 7.328125 C 2.753906 7.4375 2.875 7.5 3 7.5 L 5.625 7.5 L 5.625 11.625 C 5.625 11.800781 5.75 11.953125 5.921875 11.992188 C 5.949219 11.996094 5.972656 12 6 12 C 6.144531 12 6.28125 11.914062 6.34375 11.777344 L 9.34375 5.027344 C 9.394531 4.910156 9.382812 4.777344 9.3125 4.671875 Z M 9.3125 4.671875 "
        />
      </g>
    </svg>
  );
};

export const ThumbIcon = (props) => {
  const { fillColor = "#000000", inverted = false } = props;
  const transform = inverted ? "rotate(-180 8,8)" : null;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <g>
        <path
          transform={transform}
          fill={fillColor}
          d="m14.18743,5.8054l-4.24033,0l0,-3.25035c0,-0.93727 -0.7624,-1.69967 -1.69955,-1.69967l-0.98998,0c-0.93727,0 -1.69967,0.7624 -1.69967,1.69967l0,2.06528l-1.73998,2.17504l-2.00535,0c-0.93727,0 -1.69967,0.7624 -1.69967,1.69967l0,4.94989c0,0.93727 0.7624,1.69967 1.69967,1.69967l9.89991,0c0.8464,0 1.83133,-0.57959 2.24244,-1.31949l1.27304,-2.29142c0.36959,-0.66528 0.65914,-1.78271 0.65914,-2.54379l0,-1.48485c0,-0.93727 -0.7624,-1.69967 -1.69967,-1.69967zm-13.15026,7.63954l0,-4.94989c0,-0.42759 0.3478,-0.7754 0.7754,-0.7754l1.76538,0l0,6.50069l-1.76538,0c-0.42759,0 -0.7754,-0.3478 -0.7754,-0.7754zm13.92565,-4.45503c0,0.60595 -0.24852,1.56524 -0.54277,2.09489l-1.27316,2.29154c-0.24972,0.44962 -0.92006,0.844 -1.43442,0.844l-7.21026,0l0,-6.80072l1.87863,-2.34846c0.06559,-0.08196 0.10133,-0.18377 0.10133,-0.28871l0,-2.22739c0,-0.42759 0.3478,-0.7754 0.7754,-0.7754l0.98998,0c0.42747,0 0.77528,0.3478 0.77528,0.7754l0,3.71248c0,0.25514 0.20688,0.46213 0.46213,0.46213l4.70246,0c0.42759,0 0.7754,0.3478 0.7754,0.7754l0,1.48485zm0,0"
        />
      </g>
    </svg>
  );
};

export const CalendarIcon = (props) => {
  const { fillColor = "#ffffff" } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
      <g>
        <path
          fill={fillColor}
          d="M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V10h16v11zm0-13H4V5h16v3z"
        />
      </g>
    </svg>
  );
};
